import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-template',
  templateUrl: './select-template.component.html',
  styleUrls: ['./select-template.component.scss'],
})
export class SelectTemplateComponent implements OnInit {
  public tabs = [
    {
      name: `${this.translate.instant('COMPONENTS.MY_SCRIPT_TEMPLATES')}`,
      id: 'meus-templates',
      selected: true,
    },
    {
      name: `${this.translate.instant('COMPONENTS.READY_MADE_SCRIPT')}`,
      id: 'templates-prontos',
      selected: false,
    },
  ];
  public basepath = [];
  constructor(private router: Router, private translate: TranslateService) {}

  ngOnInit() {
    const href = this.router.url;
    this.basepath = href.split('/');
    this.basepath.pop();
  }
}
